import { Grid2, Typography, Box } from '@mui/material';
import { ACTIVITY_FEED_TYPES, COLORS, DATE_FORMATS } from '../../../utils/Application_Constants';
import formatDate from '../../../utils/formatDate';

const statusColors = {
    BP_REVIEW: COLORS.LT_SUNFLOWER,
    TC_REVIEW: COLORS.LT_EMERALD,
};

const ActivityFeedItem = ({ item }) => {
    const formattedDate = formatDate(item.timestamp, {
        format: DATE_FORMATS.SHORT_DATE,
    });
    const formattedTime = formatDate(item.timestamp, {
        format: 'hh:mma',
    }).toLowerCase();

    const statusColor = statusColors[item.status] || 'grey';
    const nameArr = item.username.split('@')[0].split('.');
    const displayName = nameArr.length > 1 ? `${nameArr[0]} ${nameArr[1]}` : nameArr[0];

    return (
        <Grid2 container direction="column" spacing={1} sx={{ pr: 0 }}>
            <Grid2 container justifyContent="space-between" alignItems="center" width="100%">
                <Grid2 display="flex" alignItems="center" gap={1.5}>
                    <Box
                        width={14}
                        height={14}
                        bgcolor={statusColor}
                        sx={{ borderRadius: '50%' }}
                    />
                    <Typography variant="body2" color={COLORS.LT_MIDNIGHT50}>
                        {formattedDate}
                    </Typography>
                </Grid2>
                <Typography variant="body2" color={COLORS.LT_MIDNIGHT50}>
                    {formattedTime}
                </Typography>
            </Grid2>

            <Grid2 container>
                <Box ml="26px">
                    <Typography
                        fontWeight="bold"
                        sx={{
                            wordBreak: 'break-word',
                            textTransform: 'capitalize',
                        }}
                    >
                        {displayName}
                    </Typography>
                    {item.type === ACTIVITY_FEED_TYPES.COMMENT ? (
                        <Box
                            dangerouslySetInnerHTML={{ __html: item.formattedCommentContent }}
                            sx={{ '& p': { m: 0 }, color: 'text.secondary' }}
                        />
                    ) : (
                        <Typography variant="body2" color="text.secondary">
                            {item.formattedCommentContent}
                        </Typography>
                    )}
                </Box>
            </Grid2>
        </Grid2>
    );
};

export default ActivityFeedItem;
